export const DESIGN_DIMENSIONS = {
    WIDTH: 710,
    HEIGHT: 920
}
